import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import * as commonFunc from 'scripts/common';

import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.css';
import 'gridstack/dist/gridstack-extra.min.css';

import CChart from 'components/CChart';

import { Button, Card, CardHeader, CardBody, CardTitle, Row } from 'reactstrap';
import Select from 'react-select';
import AGenerateModel from './generic/AGenerateModel';
import AConfigureModel from './generic/AConfigureModel';

var gridCb;
var allowPropsUpdate = false;

const CGridStack = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [resetCount, setResetCount] = React.useState(0);
    const [grid, setGrid] = React.useState();
    const [state, setState] = React.useState(props.defaultState ? true : false);
    const [items, setItems] = React.useState();
    const [rerender, setRerender] = React.useState(false);

    React.useImperativeHandle(ref, () => ({
        getGrid: () => { return grid; },
    }));

    React.useEffect(() => {
        return () => {
            if (grid) grid.destroy();
        }
    }, []);

    React.useEffect(() => {
        if (gridCb) {
            gridCb();
        }
    }, [rerender]);

    React.useEffect(() => {
        //console.debug("GRID RERENDER CACHE")
        //setRerender(!rerender);
    }, [props.parentGenArgs]);

    

    React.useEffect(() => {
        //console.debug("Init Data " + (props.dbClientID || "") + props.type);
        if (!props.isConfigurationMode || !grid || allowPropsUpdate) {
            if (allowPropsUpdate) setResetCount(resetCount+1);
            allowPropsUpdate = false;
            var defaultGridStackData;
            if (props.data && props.data.startsWith) {
                defaultGridStackData = JSON.parse(props.data);
            }
            else {
                defaultGridStackData = props.data;
            }
            var dbClientID = props.dbClientID || "";
            var optDataKey = localStorage.getItem(dbClientID + props.type);
            if (optDataKey === null) {
                optDataKey = localStorage.getItem(props.type);
                if (optDataKey === null) {
                    if (!props.isConfigurationMode && props.data) localStorage.setItem(dbClientID + props.type, props.data);
                }
                else {
                    console.debug("Load MultiClient");
                    defaultGridStackData = JSON.parse(optDataKey);
                }
            }
            else {
                defaultGridStackData = JSON.parse(optDataKey);
            }

            saveItems(defaultGridStackData);
        }
    }, [props.data]);

    React.useEffect(() => {
        //Réajustement du gridstack si changement des options
        if (grid?.getColumn() === 12 && props.gridOpts.column === "auto") {
            grid.column(1, "none");
        }
        else if (grid?.getColumn() === 1 && props.gridOpts.column === 12) {
            grid.column(12, "none");
        }
    }, [props.gridOpts]);

    React.useEffect(() => {
        if (items) {
            //console.debug("GO INIT GRIDSTACK");
            //console.debug(items);
            if (grid) grid.destroy(false);
            initGridStack();
        }
    }, [items]);

    function droppedHandler(event, prevNode, n) {
        // if we don't have a prevNode that means it came from toolbar, which today is the only nested case (else check for some node.el.getAttribute or some custom field...)
        //if (prevNode) return;

        if (props.onDropped) {
            props.onDropped(event, prevNode, n);
            allowPropsUpdate = true;
        }
        else {
            // clear the content then make it a subgrid
            n.el.querySelector('.grid-stack-item-content').innerHTML = '';

            let nodeToAdd = {
                children: (<div>TEST</div>), id: "added-" + 0 + "-" + 0, srcData: {}, noCard: true, x: 0, y: 0, w: 5/*, h: 5*/, sizeToContent: true
            };//TODO : gridItem
            //n.grid.addWidget(n.el, nodeToAdd);
            //n.grid.addWidget(nodeToAdd);
            //n.grid.makeWidget("added - " + 0 + " -" + 0);

            n.el.remove();

            items.push(nodeToAdd);
            saveItems(items);
            gridCb = (() => {
                gridCb = null;
                n.grid.destroy(false);
                initGridStack();
            });
            setRerender(!rerender);
        }
    }

    function initGridStack() {
        var options = {
            animate: true,
            width: 12,
            column: 12,//1
            heigth: 0,
            cellHeight: 70,
            placeholderClass: "grid-stack-placeholder",
            alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
            resizable: { handles: "e,se,s,sw,w" },
            minRow: 1,
            //sizeToContent: true,
            //disableDrag: true,
            //disableResize: true,
            // draggable: { handle: '.grid-stack-item-content', scroll: true, appendTo: 'body' },
            // staticGrid:true,
            /*subGridOpts: {
                animate: true,
                width: 12,
                heigth: 0,
                placeholderClass: "grid-stack-placeholder",
                alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                resizable: { handles: "e,se,s,sw,w" },
                cellHeight: 50, // should be 50 - top/bottom
                column: 12,//1
                acceptWidgets: true, // will accept .grid-stack-item by default
                margin: 5,
            },
            subGridDynamic: true*/
            ...props.gridOpts
        };

        if (!props.noOneColumn) {
            options.columnOpts = { breakpoints: [{ w: 700, c: 1 }] };//768
        }


        if (commonFunc.isMobileDevice()) {
            //options.ddPlugin = false;
            options.disableDrag = true;
            options.disableResize = true;
        }

        /*GridStack.resizeToContentCB = (el) => {
            console.debug("GO CHECK " + el.id);
            gridGlobalItems.push(...items);
            console.debug(items);//NOK STATIC
            console.debug(gridGlobalItems);//NOK STATIC
            var filtered = gridGlobalItems.filter((item) => item.id === el.id);
            if (filtered.length) {
                var data = filtered.slice(-1)[0].srcData;
                var itemsHTML = data?.grid?.getGridItems();
                itemsHTML?.forEach((itemHTML) => {
                    data?.grid?.resizeToContent(itemHTML);
                });
                console.debug("GO RESIZE CB : " + data?.bindPropResult + " / " + data?.objType);

                var parentProps = data?.functionManager?.getParentProps();
                if (parentProps) {
                    //finalizeProcess(data, parentSupProps);
                    var dataGrid = parentProps?.parentData?.grid || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.grid
                        || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.grid;
                    if (dataGrid) {
                        console.debug("FIND GRID");
                        itemsHTML = dataGrid.getGridItems();
                        itemsHTML.forEach((item) => {
                            console.debug("FIND GRID TOP");
                            console.debug(item);
                            dataGrid.resizeToContent(item);
                        });

                        console.debug(dataGrid);
                        console.debug(parentProps?.parentData?.functionManager.getParentProps()?.parentData?.grid);

                        dataGrid = parentProps?.parentData?.functionManager.getParentProps()?.parentData?.grid
                            || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.grid;
                        if (dataGrid) {
                            console.debug("FIND GRID");
                            itemsHTML = dataGrid.getGridItems();
                            itemsHTML.forEach((item) => {
                                console.debug("FIND GRID TOP");
                                console.debug(item);
                                dataGrid.resizeToContent(item);
                            });
                        }
                    }
                }
            }
        };*/
        var newGrid = GridStack.init(options, props.target ? props.target : ".grid-stack");
        newGrid.off('change').on('change', function (event, gridItems) {
            //console.debug("change");
            var flag = false;
            //var doResize = 0;
            items.forEach((item, index) => {
                var changedItem = gridItems?.filter((gridItem) => gridItem.id == item.id);
                if (changedItem && changedItem.length) {
                    var curItem = changedItem[0];
                    item.w = curItem.w;
                    item.h = curItem.h;
                    item.x = curItem.x;
                    item.y = curItem.y;
                    //item.hidden = curItem.hidden;

                    flag |= (curItem.w !== 1);

                    //MAJ boxSize srcData
                    if (item.srcData && item.srcData.allowBoxSize) {
                        item.srcData.allowBoxSize = false;
                        console.debug(event);
                        if (!item.srcData.customDesign) item.srcData.customDesign = {};
                        if (!item.srcData.customDesign.design) item.srcData.customDesign.design = {};
                        var value = (item.w * 100 / 12);
                        var boxSize = (value / 100);
                        item.srcData.customDesign.design.boxSize = (boxSize >= 0.05 ? boxSize.toString() : "0");
                        item.srcData.mergedDesign = null;    
                        item.srcData.functionManager.rerender();
                        //setRerender(!rerender);
                    }
                }

                //TODO : se passer de timeout
                //if (item.srcData) doResize = (item.srcData.objType === "category" ? 2500 : (item.srcData.objType === "header" ? 2000 : (item.srcData.objType === "group" ? 1500 : (item.srcData.objType === "itemsContainer" ? 1000 : (item.srcData.children ? 500 : 0)))));
            });
            if (flag) saveItems(items);

            var parentData = items[0].srcData?.functionManager?.getParentProps()?.parentData;
            /*if (doResize) {
                setTimeout(() => {
                    if (newGrid.el) {
                        var itemsHTML = newGrid.getGridItems();
                        console.debug(itemsHTML);
                        itemsHTML.forEach((item) => {
                            newGrid.resizeToContent(item);
                        });
                    }
                    //TEMP
                    if (parentData.grid) {
                        console.debug("GO GRID PARENT ?");
                        var itemsHTMLParent = parentData.grid.getGridItems();
                        itemsHTMLParent.forEach((item) => {
                            parentData.grid.resizeToContent(item);
                        });
                    }
                    var parentData2 = parentData?.functionManager?.getParentProps()?.parentData;
                    if (parentData2.grid) {
                        console.debug("GO GRID PARENT2 ?");
                        var itemsHTMLParent2 = parentData2.grid.getGridItems();
                        itemsHTMLParent2.forEach((item) => {
                            parentData2.grid.resizeToContent(item);
                        });
                    }
                }, doResize);
            }*/

            //Gestion SrcData
            //items.sort(function (a, b) { return parseInt(a.y) - parseInt(b.y) });
            items.sort(function (a, b) {
                var tst = parseInt(a.y) - parseInt(b.y);
                if (!tst) tst = parseInt(a.x) - parseInt(b.x);
                return tst;
            });

            if (parentData) {
                switch (parentData.objType) {
                    case "template": parentData.categories.length = 0; break;
                    case "category": parentData.headers.length = 0; break;
                    case "header":
                        //Exception >> renderLink/groupSubName = header OU groupSubName = system
                        //parentData.groups.length = 0;
                        parentData.groups = parentData.groups.filter(group => group.renderLink === "header" || group.groupSubName === "header" || group.groupSubName === "system");
                        break;
                    case "group": parentData.items.length = 0; break;//= [] nok car perte instance objet
                    case "itemsContainer": parentData.children.length = 0; break;
                    default: break;
                }
                //var itemsHTML = newGrid.getGridItems();
                console.debug(items.map((item) => item.id).join(";"));
                items.forEach((dataItem) => {
                    //console.debug(dataItem);
                    //var item = itemsHTML.filter((gridItem) => gridItem.id == item.id);
                    //if (dataItem && dataItem.length) {
                    switch (parentData.objType) {
                        case "template":
                            parentData.categories.push(dataItem.srcData);
                            break;
                        case "category":
                            parentData.headers.push(dataItem.srcData);
                            break;
                        case "header":
                            parentData.groups.push(dataItem.srcData);
                            break;
                        case "group":
                            parentData.items.push(dataItem.srcData);
                            break;
                        case "itemsContainer":
                            parentData.children.push(dataItem.srcData);
                            break;
                        default: break;
                    }
                    //console.debug(dataItem.srcData);
                    //}
                });
            }
        });
        newGrid.off('dragstart').on('dragstart', function (event, n) {
            if (props.onDragStart) props.onDragStart(event, n, items);
        });
        newGrid.off('dragstop').on('dragstop', function (event, n) {
            if (props.onDragStop) props.onDragStop(event, n, items);
        }); 
        newGrid.off('dropped').on('dropped', function (event, prevNode, n) {
            console.debug("DROPPED");

            droppedHandler(event, prevNode, n);
        });

        newGrid.off('resizestart').on('resizestart', function (event, gridItem) {
            //Activation de la modification automatique du boxSize
            items.forEach((item, index) => {
                if (gridItem.id == item.id && item.srcData?.functionManager) {
                    item.srcData.allowBoxSize = true;
                }
            });
        }); 

        if (!state) newGrid.disable();

        newGrid.srcData = props.srcData;
        newGrid.cFunctions = [];//Possible aussi de passer par le data+ref
        newGrid.cFunctions.removeItem = (id, gridAlt, noDialog) => {
            return removeItem(id, gridAlt, noDialog);
        };
        newGrid.cFunctions.conserve = (id) => {
            newGrid.addWidget({ id: id, hidden: true });
            setRerender(!rerender);
        };

        setGrid(newGrid);
    }

    function saveItems(newItems) {
        var dbClientID = props.dbClientID || "";
        if (!props.isConfigurationMode && newItems) localStorage.setItem(dbClientID + props.type, JSON.stringify(newItems, (key, value) => {
            if (key === "srcData") {
                return undefined;
            }
            return value;
        }));
        setItems(newItems);
    }


    function addNewWidget(id) {
        var newItem;
        items.forEach((item) => {
            if (item.id == id) {
                item.hidden = false;
                newItem = item;
            }
        });

        saveItems(items);
        gridCb = (() => {
            gridCb = null;
            if (newItem) {
                grid.makeWidget('#' + newItem.id);
            }
            setRerender(!rerender);
        });
        setRerender(!rerender);
    }

    function removeItem(id, gridAlt, noDialog) {
        var targetGrid = gridAlt || grid;
        var removedData;

        var toRemove = false;
        targetGrid.getGridItems().forEach((gridItem, index) => {
            if (gridItem.gridstackNode && gridItem.gridstackNode.id == id) {
                var gridRemoveProcess = () => {
                    if (!props.withRemove) newItems = items;
                    saveItems(newItems);
                    gridCb = (() => {
                        gridCb = null;
                        targetGrid.removeWidget(gridItem.gridstackNode.el, false);
                        setRerender(!rerender);
                    });
                    setRerender(!rerender);
                };

                var newItems = [];
                items.forEach((item) => {
                    if (item.id == gridItem.gridstackNode.id) {
                        var removeProcess = () => {
                            toRemove = true;

                            item.hidden = true;
                            if (item.srcData?.functionManager?.getParentProps) {
                                var parent = item.srcData.functionManager?.getParentProps()?.parentData;
                                switch (parent.objType) {
                                    case "template":
                                        removedData = parent.categories.splice(parent.categories.indexOf(item.srcData), 1);
                                        break;
                                    case "category":
                                        removedData = parent.headers.splice(parent.headers.indexOf(item.srcData), 1);
                                        break;
                                    case "header":
                                        removedData = parent.groups.splice(parent.groups.indexOf(item.srcData), 1);
                                        break;
                                    case "group":
                                        removedData = parent.items.splice(parent.items.indexOf(item.srcData), 1);
                                        break;
                                    default:
                                        removedData = parent.children.splice(parent.children.indexOf(item.srcData), 1);
                                        break;
                                }
                                console.debug(parent);
                                //parent.functionManager?.rerender(true);// /!\ cause de disparition de composant...

                            }
                        };

                        var currChild = 0;
                        switch (item.srcData?.objType) {
                            case "template":
                                currChild = item.srcData.categories?.length;
                                break;
                            case "category":
                                currChild = item.srcData.headers?.length;
                                break;
                            case "header":
                                currChild = item.srcData.groups?.length;
                                break;
                            case "group":
                                currChild = item.srcData.items?.length;
                                break;
                            default:
                                currChild = item.srcData?.children?.length;
                                break;
                        }
                        if (!noDialog && currChild > 0) {
                            Swal.fire({
                                icon: "question",
                                title: "Suppression",
                                html: "Êtes-vous sûr de vouloir supprimer cet élément ?<br/>(des éléments sont encore présents à l'intérieur)",
                                showCancelButton: true,
                                confirmButtonColor: "#28a745",
                                cancelButtonColor: "#dc3545",
                                confirmButtonText: "Oui",
                                cancelButtonText: "Non"
                            }).then((result) => {
                                if (result.value) {
                                    removeProcess();
                                    gridRemoveProcess();
                                }
                            });
                        }
                        else {
                            removeProcess();
                        }
                    }
                    else {
                        newItems.push(item);
                    }
                });
                if (toRemove) gridRemoveProcess();
            }
        });
        return removedData;
    }

    function clearWidgets() {
        var newItems = [];
        items.forEach((item) => {
            item.hidden = true;
        });

        if (!props.withRemove) newItems = items;
        saveItems(newItems);
        gridCb = (() => {
            gridCb = null;
            grid.removeAll(false);
            setRerender(!rerender);
        });
        setRerender(!rerender);
    }

    function resetOptions() {
        var dbClientID = props.dbClientID || "";
        localStorage.removeItem(dbClientID + props.type);
        localStorage.removeItem(props.type);
        var newItems = JSON.parse(props.data);


        saveItems(newItems);
        gridCb = (() => {
            gridCb = null;
            grid.destroy(false);
            initGridStack();
            //setRerender(!rerender);
            //TODO : render ne mais pas a jour les sizes
        });
        setRerender(!rerender);
    }

    function changeState() {
        if (state) {
            grid.disable();
            setState(false);
        }
        else {
            grid.enable();
            setState(true);
        }
    }

    //console.debug("GO RENDER !!!!!");
    //console.debug(items);

    //Voir pour gérer le gridstack dans un model + un model par item



    /*<div className="grid-stack-item border-dark" data-gs-width="4" data-gs-height="4">
                <div className="grid-stack-item-content">Item 1</div>
            </div>
            <div className="grid-stack-item border-dark" data-gs-width="4" data-gs-height="4">
                <div className="grid-stack-item-content">Item 2</div>
            </div>
            <div className="grid-stack-item border-dark" data-gs-width="4" data-gs-height="4">
                <div className="grid-stack-item-content">Item 3</div>
            </div> */

    var childProps = Object.assign({}, props);
    childProps.children = null;

    return (<div className={`${props.className} ${state ? "edit-gridstack" : ""} ${props.isConfigurationMode && state ? "pt-3" : ""} `} style={props.style}>
        <Row>
            {props.children}
            {!props.isConfigurationMode && !props.hideButtons ? <><Button className="btn btn-icon btn-round" onClick={() => { changeState(); }}><i className="fa fa-gear"></i></Button>
                <Button className={`btn btn-icon btn-round ${state ? "" : "d-none"}`} color="danger" onClick={() => { resetOptions(); }} title="Réinitialiser"><i className="fa fa-trash"></i></Button>
                <Select isMulti={true} className={`${state ? "" : "d-none"}`} onChange={(e, target) => {
                    if (target.action === "remove-value") {
                        removeItem(target.removedValue.value)
                    }
                    else if (target.action === "select-option") {
                        addNewWidget(target.option.value);
                    }
                    else if (target.action === "clear") {
                        clearWidgets();
                    }
                    else {
                        //TODO : Create option
                    }
                }} value={items ? items.map((item) => {
                    if (!item.hidden) {
                        return { value: item.id, label: item.title };
                    }
                    else {
                        return "";
                    }
                }) : []}
                    options={items ? items.map((item) => { return { value: item.id, label: item.title } }) : []} />
            </> : ""}
        </Row>
        <div className={`grid-stack grid-stack-${props.type} ${props.target ? props.target : ""} ${props.gridClass ? props.gridClass : ""} ${items?.length}`}>
            {items ? items.map((item, index) => {
                if (!item.srcData) item.srcData = { rerender: () => { setRerender(!rerender) } };
                item.srcData.grid = grid;

                return (item.hidden ? "" : <div key={item.id + resetCount} id={item.id} gs-id={item.id} className={`grid-stack-item border-dark ${item.selected ? "selected-item" : ""} ${item.itemClass}`}
                    gs-x={item.x} gs-y={item.y} gs-w={item.w} gs-h={item.h} onClick={(e) => {
                    e.stopPropagation();

                    if (!e.target?.closest(".fragShortcut")) {
                        if (item.srcData) item.srcData.lastEvent = e;
                        props.triggerClick ? props.triggerClick(grid, item.srcData) : console.debug("noClick");
                    }
                }}>
                    <div className="grid-stack-item-content">
                        <div className={`${item.srcData ? "spacing-grid-item" : ""} ${item.srcData.fullHeight ? "h-100" : ""}`}>
                            <div className={`widget-actions ${state ? "" : "d-none"}`}>
                                <div className="widget-hide pull-right me-3">
                                    <div className="fragTools">
                                        <div className="fragInfos" title={t("editor.type_" + item.srcData?.objType) + (item.srcData?.bindPropResult ? (" | " + item.srcData?.bindPropResult) : "")}>
                                            {t("editor.type_" + item.srcData?.objType)} {(item.srcData?.bindPropResult ? (" | " + item.srcData?.bindPropResult) : "")}
                                        </div>
                                        <div className="fragShortcut">
                                            <i className="fa fa-copy frag-clone"></i>
                                            <i className="fa fa-pencil frag-edit"></i>
                                            <i className="fa fa-trash frag-remove" onClick={() => removeItem(item.id)}></i>
                                        </div>
                                    </div>
                                    <a className="" onClick={() => removeItem(item.id)}>
                                        <i className={`fa fa-times remove-gridstack ${props.actionsClass ? props.actionsClass : ""}`}></i>
                                    </a>
                                </div>
                            </div>
                            {grid ? (!props.isConfigurationMode ? (props.configModel && props.configModel[item.type] ? <AGenerateModel {...childProps} parentProps={{ type: "tdb" }} /*ref={parentContext.modalGenManager}*/ noButtons /*onSubmit={(data, isUpdate) => callback(data, isUpdate)} appProps={parentContext.props} checkRights={parentContext.props.checkRights}
                        getRoutes={parentContext.props.getRoutes}*/ configModel={props.configModel ? JSON.parse(JSON.stringify(props.configModel[item.type])) : {}} modelsList={props.configModel ? props.configModel : []} loadedData={item} />
                                : <CGridStackItem className="text-dark" src={item} t={t} altT={altT}>{item.children}</CGridStackItem>)
                                : (props.configModel && props.configModel[item.type] ? <AConfigureModel {...childProps} parentProps={{ type: "tdb" }} /*ref={parentContext.modalGenManager}*/ noButtons /*onSubmit={(data, isUpdate) => callback(data, isUpdate)} appProps={parentContext.props} checkRights={parentContext.props.checkRights}
                        getRoutes={parentContext.props.getRoutes}*/ configModel={props.configModel ? JSON.parse(JSON.stringify(props.configModel[item.type])) : {}} traceModel={props.configModel ? (JSON.stringify(props.configModel[item.type])) : ""} modelsList={props.configModel ? props.configModel : []} loadedData={item} />
                                    : <CGridStackItem className="text-dark" src={item} t={t} altT={altT}>{item.children}</CGridStackItem>)) : ""}
                        </div>
                    </div>
                </div>);
            }) : ""}
        </div>
    </div>);
});

export default CGridStack;



export function CGridStackItem(props) {
    var { src, t, children } = props;//icon, title, altT

    const [data, setData] = React.useState(src.data);
    const [altData, setAltData] = React.useState(src.altData || { labels: [], datasets: [] });
    const [refreshData, setRefreshData] = React.useState(false);

    React.useEffect(() => {
        switch (src.type) {
            case "CHART_USERSCON":
                commonFunc.getMethod("../api/GetUserUsageStatement", { period: "M" }).then((responseData) => {
                    var dataRes = responseData.data;
                    if (dataRes.isSuccess) {

                        console.debug(dataRes.result);

                        var userLabels = [];
                        var usersDataset = [];
                        var devicesDataset = [];
                        var dataUserCount = 0;
                        dataRes.result.forEach((userStatement, index) => {
                            userLabels.push(userStatement.period);
                            //userLabels.push(moment(userStatement.period, "YYYY-MM").format("MMM YYYY"));

                            usersDataset.push(userStatement.usersCount);
                            devicesDataset.push(userStatement.devicesCount);

                            console.debug(userStatement.usersCount);
                            dataUserCount = userStatement.usersCount;
                        });
                        setData(dataUserCount);

                        /*setAltData({
                            labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                            datasets: [
                                {
                                    label: "Mobile apps",
                                    color: "#1A73E8",
                                    data: [15, 85, 300, 220, 500, 250, 400, 230, 500],
                                },
                                {
                                    label: "Websites",
                                    color: "#D81B60",
                                    data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
                                },
                            ],
                        });*/
                        setAltData({
                            labels: userLabels,
                            datasets: [
                                {
                                    label: "Utilisateurs",
                                    color: "#1A73E8",
                                    data: usersDataset,
                                },
                                {
                                    label: "Appareils",
                                    color: "#D81B60",
                                    data: devicesDataset,
                                },
                            ],
                        });

                        commonFunc.getMethod("../api/GetOnlineUsers", null).then((responseData) => {
                            var dataRes = responseData.data;
                            if (dataRes.isSuccess) {
                                var dataDistinctUsers = [];

                                dataRes.result.forEach((userOnline, index) => {
                                    if (dataDistinctUsers.indexOf(userOnline.id) < 0) dataDistinctUsers.push(userOnline.id);
                                });

                                setData(dataDistinctUsers.length);
                            }
                        });

                    } else {
                        /*Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_fail"),
                            html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                        });*/
                    }
                });

                break;
            default:
                break;
        }
    }, [refreshData]);

    var mValue = "";
    var mIcon = "";
    var mTitle = src.title;
    switch (src.type) {
        case "CHART_USERSCON":
            mValue = (<>
                <Button className="btn btn-simple btn-rotate btn-dark btn-sm px-2 mt-0 mb-0" onClick={() => { setRefreshData(!refreshData); }}><i className="fa fa-sync"></i>{t("gal_refresh")}</Button>
                <CChart type="line" redraw
                className="d-inline-block align-top"
                style={{ width: "100%", height: "250px" }}
                data={altData}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                    interaction: {
                        intersect: false,
                        mode: "index",
                    },
                    scales: {
                        y: {
                            grid: {
                                drawBorder: false,
                                display: true,
                                drawOnChartArea: true,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: true,
                                padding: 10,
                                color: "#b2b9bf",
                                font: {
                                    size: 11,
                                    family: "Roboto",
                                    style: "normal",
                                    lineHeight: 2,
                                },
                            },
                        },
                        x: {
                            grid: {
                                drawBorder: false,
                                display: false,
                                drawOnChartArea: false,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: true,
                                color: "#b2b9bf",
                                padding: 20,
                                font: {
                                    size: 11,
                                    family: "Roboto",
                                    style: "normal",
                                    lineHeight: 2,
                                },
                            },
                        },
                    },
                    }} />
            </>);

            mIcon = <i className="fa fa-user" style={{ fontSize: "35px" }}></i>;
            mTitle = <><span className="me-2" style={{ fontSize: "20px" }}>{data}</span><span>{src.title}</span></>;
            break;
        default:
            break;
    }

    return src.noCard ? <div className={`row m-0 ${props.className}`}>{children}</div> : (<Card /*{...props}*/ className={`widget dash h-100 ${props.className}`}>
        <CardHeader className="pt-0">
            <CardTitle tag="h6" className="mt-3">{mTitle}</CardTitle>
            <div className="widget-tools collapse-tool">
                {mIcon}
            </div>
            <div className='borderTheme'></div>
        </CardHeader>
        <CardBody className={``}>
            {mValue}
            {children}
        </CardBody>
    </Card>);
}